import { DataService } from "@/services/data";
import { handle_error, handle_success } from "@/utils/wretch";
import { RouteObject } from "react-router-dom";

const MessageRoute: RouteObject = {
    path: "message",

    action: async ({ request }) => {
        const data = await request.json();
        try {
            const response = await DataService.client.url(`/tools/message/`).post(data).json();
            return handle_success(response);
        } catch (e) {
            return handle_error(e);
        }
    }
};
export default MessageRoute;
